"use strict";

var _classCallCheck = require("/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var React = require('react'),
    ReactDOM = require('react-dom'),
    S3Upload = require('./s3upload.js');

var ReactS3Uploader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ReactS3Uploader, _React$Component);

  function ReactS3Uploader() {
    _classCallCheck(this, ReactS3Uploader);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReactS3Uploader).apply(this, arguments));
  }

  _createClass(ReactS3Uploader, [{
    key: "uploadFile",
    value: function uploadFile() {
      this.myUploader = new S3Upload({
        fileElement: ReactDOM.findDOMNode(this),
        signingUrl: this.props.signingUrl,
        getSignedUrl: this.props.getSignedUrl,
        preprocess: this.props.preprocess,
        onSignedUrl: this.props.onSignedUrl,
        onProgress: this.props.onProgress,
        onFinishS3Put: this.props.onFinish,
        onError: this.props.onError,
        signingUrlMethod: this.props.signingUrlMethod,
        signingUrlHeaders: this.props.signingUrlHeaders,
        signingUrlQueryParams: this.props.signingUrlQueryParams,
        signingUrlWithCredentials: this.props.signingUrlWithCredentials,
        uploadRequestHeaders: this.props.uploadRequestHeaders,
        contentDisposition: this.props.contentDisposition,
        server: this.props.server,
        scrubFilename: this.props.scrubFilename,
        s3path: this.props.s3path
      });
    }
  }, {
    key: "abort",
    value: function abort() {
      this.myUploader && this.myUploader.abortUpload();
    }
  }, {
    key: "clear",
    value: function clear() {
      clearInputFile(ReactDOM.findDOMNode(this));
    }
  }, {
    key: "render",
    value: function render() {
      return [React.createElement('input', this.getInputProps()), React.createElement('label', {
        key: 1,
        htmlFor: this.props.htmlId
      }, this.props.label)];
    }
  }, {
    key: "getInputProps",
    value: function getInputProps() {
      // declare ref beforehand and filter out
      // `inputRef` by `ReactS3Uploader.propTypes`
      var additional = {
        type: 'file',
        ref: this.props.inputRef
      };

      if (this.props.autoUpload) {
        additional.onChange = this.uploadFile.bind(this);
      }

      var temporaryProps = Object.assign({}, this.props, additional);
      var inputProps = {};
      var invalidProps = ['signingUrl', 'getSignedUrl', 'preprocess', 'onSignedUrl', 'onProgress', 'onFinish', 'onError', 'signingUrlMethod', 'signingUrlHeaders', 'signingUrlQueryParams', 'signingUrlWithCredentials', 'uploadRequestHeaders', 'contentDisposition', 'server', 'scrubFilename', 's3path', 'inputRef', 'autoUpload', 'label', 'htmlId'];

      for (var key in temporaryProps) {
        if (temporaryProps.hasOwnProperty(key) && invalidProps.indexOf(key) === -1) {
          inputProps[key] = temporaryProps[key];
        }
      }

      inputProps.id = this.props.htmlId;
      inputProps.key = 0;
      return inputProps;
    }
  }]);

  return ReactS3Uploader;
}(React.Component);

ReactS3Uploader.defaultProps = {
  preprocess: function preprocess(file, next) {
    console.log('Pre-process: ' + file.name);
    next(file);
  },
  onSignedUrl: function onSignedUrl(signingServerResponse) {
    console.log('Signing server response: ', signingServerResponse);
  },
  onProgress: function onProgress(percent, message, file) {
    console.log('Upload progress: ' + percent + '% ' + message);
  },
  onFinish: function onFinish(signResult) {
    console.log("Upload finished: " + signResult.publicUrl);
  },
  onError: function onError(message) {
    console.log("Upload error: " + message);
  },
  server: '',
  signingUrlMethod: 'GET',
  scrubFilename: function scrubFilename(filename) {
    return filename.replace(/[^\w\d_\-\.]+/ig, '');
  },
  s3path: '',
  autoUpload: true
}; // http://stackoverflow.com/a/24608023/194065

function clearInputFile(f) {
  if (f.value) {
    try {
      f.value = ''; //for IE11, latest Chrome/Firefox/Opera...
    } catch (err) {}

    if (f.value) {
      //for IE5 ~ IE10
      var form = document.createElement('form'),
          parentNode = f.parentNode,
          ref = f.nextSibling;
      form.appendChild(f);
      form.reset();
      parentNode.insertBefore(f, ref);
    }
  }
}

module.exports = ReactS3Uploader;